import { render } from "./preferences-settings.vue?vue&type=template&id=2a263f2f"
import script from "./preferences-settings.vue?vue&type=script&lang=js"
export * from "./preferences-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__